import React, { Component } from 'react';
import { connect } from 'react-redux';

class InfoCard extends Component {

	render () {
		return <div className={'card'}>
			<div className={'card-body'}>
				<div style={{display:'table',width: '100%',height: '60px'}}>
					{
						this.props.icon?
							<i className={'text-left text-primary '+this.props.icon} style={{fontSize:'40px'}}></i>
						:
						null
					}
					{
						this.props.small?
							<small className="text-right text-muted text-uppercase font-weight-bold center_dash_label">
								{this.props.small}
							</small>
						:
						null
					}
				</div>
					
				{
					this.props.text?
					<div className="text-value text-right">
						{this.props.text}
					</div>
					:
					null
				}
			</div>
		</div>
	}
}

const mapStateToProps = (state) => {
	return {
		json_lang: state.json_lang,
		currency: state.currencies.local.symbol,
		orders: state.orders
	}
}


export default connect(mapStateToProps)(InfoCard);


// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/InfoCard.js